var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"my-modal",attrs:{"hide-footer":"","title":"Achtung"}},[_c('div',{staticClass:"d-block text-center"},[_c('h3',{staticClass:"text-danger"},[_vm._v("Sitzung läuft in Kürze ab")]),_c('p',[_vm._v("Bitte bewegen Sie die Maus.")]),_c('p',[_vm._v("Sie haben noch "+_vm._s(_vm.time / 1000)+" Sekunden")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }